import utility from '../assets/image1.png'
import tokenMetric from '../assets/image2.png'
import myTonWallet from '../assets/image3.png'
import FootballFest from '../assets/image4.png'
import Fantons from '../assets/news5.png'



export const tasks = [
    {
      id: "0",
      image: utility,
      task_status: "Ongoing",
      task_status_message: "Challenge is Open",
      bonus_total: 1000000,
      title: "Perform tasks, Earn $Squad token",
      user_point_score: 0,
      company: "Utility of MY",
      desc: "Ends in 4 days, after which active campaign participants will share 3,000,000 MY tokens. So, what features will MY holders have?",
      task: [
        {
          task_title: "Follow us on instagram",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "60",
        },
        {
          task_title: "Follow us on Facebook",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "30",
        },
        {
          task_title: "Follow us on TickTok",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "100",
        },
      ],
      about: [
        {
          id: "1",
          desc: " Access to premium features. MY holders will have exclusive access to advanced features to control and interact with the wallet.",
        },
        {
          id: "2",
          desc: "Swap discounts. Every swap saves MY holders their Toncoin for paying fees.",
        },
        {
          id: "3",
          desc: "Increased yields with staking. MY holders get the best conditions for staking Toncoin in MyTonWallet. ",
        },
        {
          id: "4",
          desc: "DAO voting. Get a voice in the future development of MyTonWallet. ",
        },
        {
          id: "5",
          desc: "Early access to new features. Tokenholders will get early access to new features and updates before public release. ",
        },
      ]
    },
    {
      id: "1",
      image: tokenMetric,
      task_status: "Finished",
      task_status_message: "Challenge is Finished",
      bonus_total: 3000000,
      user_point_score: 3000,
      company: "MY tokenomics",
      title: "Future utility token of Tokenomics",
      desc: "MY tokenomics | MyTonWallet MY is the future utility token of MyTonWallet, one of the major wallets in TON ecosystem. ",
      task: [
        {
          task_title: "Follow us on instagram",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "60",
        },
        {
          task_title: "Follow us on Facebook",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "30",
        },
        {
          task_title: "Follow us on TickTok",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "100",
        },
      ],
      about: [
        {
          id: "1",
          desc: " Initial cap: $5M",
        },
        {
          id: "2",
          desc: "Total issuance: 50M MY",
        },
        {
          id: "3",
          desc: "TGE date:  May 7 ",
        },
        {
          id: "4",
          desc: "30% Airdrop: The main airdrop that all active wallet users will receive. A snapshot was taken on April 12 👀 ",
        },
        {
          id: "5",
          desc: "25% Ecosystem Development (Reserve Fund) ",
        },
      ]
    },
    {
      id: "2",
      image: myTonWallet,
      task_status: "Ongoing",
      task_status_message: "Challenge is Open",
      bonus_total: 3000000,
      user_point_score: 50000,
      company: "MyTonWallet",
      title: "MyTonWallet is now live on Early",
      desc: "Early kicked off it's first campaign with MyTonWallet. Get involved, support an early-stage project, complete tasks, and share in 3,000,000 $MY tokens.",
      task: [
        {
          task_title: "Follow us on instagram",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "60",
        },
        {
          task_title: "Follow us on Facebook",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "30",
        },
        {
          task_title: "Follow us on TickTok",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "100",
        },
      ],
      about: [
        {
          id: "1",
          desc: " Early is a platform dedicated to launching early-stage projects. Here, the community plays a vital role in the project's growth, and in return, tokens are shared with those who contribute. ",
        },
        {
          id: "2",
          desc: " No token sales or whitelists here, pure support from the community only. ",
        },
        {
          id: "3",
          desc: "Join us now  (https://t.me/early_adopters/17) and be a part of something special!.",
        },    
      ]
    },
    {
      id: "3",
      image: FootballFest,
      task_status: "Finished",
      task_status_message: "Challenge is Closed",
      bonus_total: 1000000,
      user_point_score: 0,
      title: "Community x Football Fest: Results",
      company: "Football Fest",
      desc: "Over 1 million people participated in the draw for cash and a whitelist (WL) spots for Fanton’s initial decentralized exchange offering (IDO). ",
      task: [
        {
          task_title: "Follow us on instagram",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "60",
        },
        {
          task_title: "Follow us on Facebook",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "30",
        },
        {
          task_title: "Follow us on TickTok",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "100",
        },
      ],
      about: [
        {
          id: "1",
          desc: " The cash prizes already delivered to the winners’ wallets. WLs are reserved for those who reach over 3k points; the list can be found in the table above.☝️ ",
        },
        {
          id: "2",
          desc: "Read more about distribution here (https://t.me/fanton_nft_en/6368).",
        },
        {
          id: "3",
          desc: "It’s been a great football campaign, frens. Share your trophies in the comments 🏆. ",
        },
       
      ]
    },
    {
      id: "4",
      image: Fantons,
      task_status: "Ongoing",
      task_status_message: "Challenge is Open",
      bonus_total: 85000,
      user_point_score: 0,
      company: "Fanton’s $85,000",
      title: "Fanton’s $85,000 awaits winners in just 4 days",
      desc: "Almost half a million people took part in the Community x Fanton campaign! To compare, the biggest stadiums in the world hold around 100,000 people.🤯",
      task: [
        {
          task_title: "Follow us on instagram",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "60",
        },
        {
          task_title: "Follow us on Facebook",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "30",
        },
        {
          task_title: "Follow us on TickTok",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "100",
        },
      ],
      about: [
        {
          id: "1",
          desc: " 🏆 To win, you don’t just have to go to the stadium—you have to cheer. The $85,000 will be distributed to those who score more than 1,000 points by completing tasks.",
        },
        {
          id: "2",
          desc: "New deadline: April 1, 12:00 UTC",
        },
        {
          id: "3",
          desc: "Join the challenge (https://t.me/community_bot/join?startapp=id_164) ",
        },
       
      ]
    },
  
  ];

export const realTasks = [
    {
      id: "0",
      task_status: "Ongoing",
      task_status_message: "Challenge is Open",
      bonus_total: 1000000,
      title: "Do Tasks, Earn $NEXAI Token",
      user_point_score: 0,
      company: "Utility of MY",
      desc: "Ends in 4 days, after which active campaign participants will share 3,000,000 MY tokens. So, what features will MY holders have?",
      task: [
        {
          task_title: "Join us on Telegram",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "5000",
          task_status: true,
          task_link: "https://t.me/nexabitHQ"
        },
        {
          task_title: "Follow us on Twitter",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "7000",
          task_status: true,
          task_link: "https://x.com/nexabitHQ"
        },
        {
          task_title: "Subscribe to NexaBit YouTube Channel",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "10000",
          task_status: true,
          task_link: "https://www.youtube.com/@NexaBitHQ"
        },
        {
          task_title: "Join us on LinkedIn",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "12000",
          task_status: true,
          task_link: "https://www.linkedin.com/company/nexabithq/"
        },
        {
          task_title: "Follow us on Tiktok",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "5000",
          task_status: false,
          task_link: "https://www.tiktok.com/@nexabithq"
        },
        {
          task_title: "Follow us on FaceBook",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "5000",
          task_status: true,
          task_link: "https://www.facebook.com/nexabitHQ"
        },
        {
          task_title: "Follow us on InstaGram",
          task_desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis laudantium facilis nisi iusto ut.",
          task_points: "5000",
          task_status: false,
          task_link: "https://www.instagram.com/nexabithq"
        },
      ],
      about: [
        {
          id: "1",
          desc: " Access to premium features. MY holders will have exclusive access to advanced features to control and interact with the wallet.",
        },
        {
          id: "2",
          desc: "Swap discounts. Every swap saves MY holders their Toncoin for paying fees.",
        },
        {
          id: "3",
          desc: "Increased yields with staking. MY holders get the best conditions for staking Toncoin in MyTonWallet. ",
        },
        {
          id: "4",
          desc: "DAO voting. Get a voice in the future development of MyTonWallet. ",
        },
        {
          id: "5",
          desc: "Early access to new features. Tokenholders will get early access to new features and updates before public release. ",
        },
      ]
    }, 
  ];